import { restRequest } from 'core/utils/backend-service';
import {
    CREATE_EAP_SETTING_REST_ENDPOINT,
    CreateEapSettingsApiRequest,
    IMPORT_EAP_SETTINGS_REST_ENDPOINT,
    ImportEapSettingsApiRequest,
    UPDATE_EAP_SETTING_REST_ENDPOINT,
    UpdateEapSettingsApiRequest,
} from './eap-settings-rest.api';

const buildEapSettingsFormData = (payload: CreateEapSettingsApiRequest | UpdateEapSettingsApiRequest): FormData => {
    const formData = new FormData();

    // Add the EAP content as JSON with application/json content type
    const eapContentBlob = new Blob([JSON.stringify(payload.eapContent)], { type: 'application/json' });
    formData.append('eapContent', eapContentBlob);

    // Add certificate files if provided
    if (payload.caCertificate) {
        formData.append('caCertificate', payload.caCertificate);
    }

    if (payload.clientCertificate) {
        formData.append('clientCertificate', payload.clientCertificate);
    }

    if (payload.clientPrivateKey) {
        formData.append('clientPrivateKey', payload.clientPrivateKey);
    }

    return formData;
};

export const createEapSetting = async (payload: CreateEapSettingsApiRequest): Promise<{ result: string }> => {
    const formData = buildEapSettingsFormData(payload);
    return restRequest('POST', `${CREATE_EAP_SETTING_REST_ENDPOINT}`, { body: formData }).then(() => ({
        result: 'ok',
    }));
};

export const updateEapSetting = async (payload: UpdateEapSettingsApiRequest): Promise<{ result: string }> => {
    const formData = buildEapSettingsFormData(payload);
    return restRequest('PUT', `${UPDATE_EAP_SETTING_REST_ENDPOINT}`, { body: formData }).then(() => ({
        result: 'ok',
    }));
};

const appendFiles = (formData: FormData, field: string, files?: File[]) => {
    for (const file of files ?? []) {
        formData.append(field, file);
    }
};

const buildEapSettingsImportFormData = (payload: ImportEapSettingsApiRequest): FormData => {
    const formData = new FormData();

    formData.append('namingStrategy', payload.namingStrategy);
    // Add the EAP content as JSON with application/json content type
    const eapContentBlob = new Blob([JSON.stringify(payload.eapContent)], { type: 'application/json' });
    formData.append('eapContent', eapContentBlob);

    appendFiles(formData, 'caCertificates', payload.caCertificates);
    appendFiles(formData, 'clientCertificates', payload.clientCertificates);
    appendFiles(formData, 'privateKeys', payload.privateKeys);

    return formData;
};

export const importEapSettings = async (payload: ImportEapSettingsApiRequest): Promise<{ result: string }> => {
    const formData = buildEapSettingsImportFormData(payload);
    return restRequest('POST', `${IMPORT_EAP_SETTINGS_REST_ENDPOINT}`, { body: formData }).then(() => ({
        result: 'ok',
    }));
};
